module.exports = __webpack_public_path__ + "img/logo.f01ba787.jpeg";